const PasswordRequirements = ({ password, oldPassword }) => {
  const requirements = [
    {
      text: 'At least 10 characters (and up to 100 characters)',
      check: password.length >= 10 && password.length <= 100,
    },
    {
      text: 'At least one lowercase character',
      check: /[a-z]/.test(password),
    },
    {
      text: 'Inclusion of at least one special character, e.g., ! @ # ?',
      check: /[!@#?$%^&*]/.test(password),
    },
    {
      text: 'Significantly different from your previous passwords',
      check: oldPassword !== password,
    },
  ];

  return (
    <div className="col-span-1 rounded-lg bg-gray-50 p-4 dark:bg-gray-700">
      <h3 className="mb-1 text-sm font-medium text-gray-900 dark:text-white">Password requirements:</h3>
      <p className="mb-4 text-sm font-normal text-gray-500 dark:text-gray-400">Ensure that these requirements are met:</p>
      <ul className="space-y-2 text-sm text-gray-500 dark:text-gray-400">
        {requirements.map((req, index) => (
          <li key={index} className="flex items-center">
            {req.check ? (
              <svg className="me-2 size-4 shrink-0 text-green-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fillRule="evenodd" d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm13.7-1.3a1 1 0 0 0-1.4-1.4L11 12.6l-1.8-1.8a1 1 0 0 0-1.4 1.4l2.5 2.5c.4.4 1 .4 1.4 0l4-4Z" clipRule="evenodd"></path>
              </svg>
            ) : (
              <svg className="me-2 size-4 shrink-0 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fillRule="evenodd" d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm7.7-3.7a1 1 0 0 0-1.4 1.4l2.3 2.3-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3 2.3 2.3a1 1 0 0 0 1.4-1.4L13.4 12l2.3-2.3a1 1 0 0 0-1.4-1.4L12 10.6 9.7 8.3Z" clipRule="evenodd"></path>
              </svg>
            )}
            {req.text}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PasswordRequirements;
